interface IconProps {
	className?: string;
}

export const NftIcon = ({ className = 'inline-block h-5 w-5' }: IconProps) => {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM4.071 13.071C4.30601 14.8071 5.10416 16.4182 6.34298 17.657C7.5818 18.8958 9.19287 19.694 10.929 19.929C10.6941 18.1925 9.89594 16.5811 8.6569 15.3421C7.41786 14.1031 5.80646 13.3049 4.07 13.07M19.928 13.07C18.1919 13.305 16.5808 14.1032 15.342 15.342C14.1032 16.5808 13.305 18.1919 13.07 19.928C14.8061 19.693 16.4172 18.8948 17.656 17.656C18.8948 16.4172 19.693 14.8061 19.928 13.07ZM12 7.364C11.0169 9.38448 9.38448 11.0169 7.364 12C9.38448 12.9831 11.0169 14.6155 12 16.636C12.9831 14.6155 14.6155 12.9831 16.636 12C14.6155 11.0169 12.9831 9.38448 12 7.364ZM10.929 4.071C9.19261 4.30602 7.58129 5.10427 6.34228 6.34328C5.10327 7.58229 4.30502 9.19361 4.07 10.93C5.80678 10.6953 7.41853 9.89704 8.65778 8.65778C9.89704 7.41853 10.6953 5.80678 10.93 4.07M13.072 4.07C13.307 5.80613 14.1052 7.4172 15.344 8.65602C16.5828 9.89484 18.1939 10.693 19.93 10.928C19.6949 9.19158 18.8965 7.58029 17.6572 6.34143C16.418 5.10257 14.8065 4.3046 13.07 4.07"
				fill="currentColor"
			/>
		</svg>
	);
};
